<template>
  <div>
    <b-modal
      ref="modal-settings-entity-group"
      :title="$t('Areas by module') | capitalize"
      modal-class="modal-primary"
      @hidden="$emit('hideModal')"
      size="md"
    >
      <div class="scroll-kanban">
        <ValidationObserver ref="form-settings-homework-status">
          <div>
            <b-row class="border-right">
              <!-- Abrevisions -->
              <b-col md="12">
                <b-form-group :label="$t('Type')">
                  <b-form-select
                    v-model="area"
                    :options="areasOptions()"
                    value-field="id"
                    text-field="name"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                <div class="overflow-auto" style="height: 300px">
                  <div
                    v-for="(item, index) in itemsFiltered()" 
                    :key="index"
                    class="mt-1 border-bottom row justify-content-between overflow-auto"
                  >
                    <div class="pl-2 pr-2">
                      <b-avatar size="sm" rounded variant="light-success" />
                      <span>
                        {{ item.area_name }}
                      </span>
                    </div>
                    <feather-icon
                      icon="DeleteIcon"
                      size="20"
                      class="text-danger mr-2 cursor-pointer"
                      @click="deleteItem(item)"
                    />
                  </div>
                </div>
              </b-col>
            </b-row> 
          </div>
        </ValidationObserver>
      </div>
      <template #modal-footer>
        <b-container fluid>
          <b-row>
            <b-col class="d-flex align-items-center justify-content-end p-0">
              <b-button class="mr-1" @click="$emit('closeModal')" v-t="'Cancel'">
              </b-button>
              <b-button variant="primary" @click="save">
                Guardar
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>
  </div>
</template>

<script>
import modalMixin from "@/mixins/modal";
import AreasModuleService from "@/views/settings/views/areas-module/service/areas-module.service.js";
import { VueAutosuggest } from "vue-autosuggest";
import { mapGetters } from "vuex";
export default {
  mixins: [modalMixin],
  components: {
    VueAutosuggest,
  },
  props: {
    modalData: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      areas: [],
      area: {},
      areasSelected: [],
      initialAreaIds: [],
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser"
    }),
  },
  watch:{
    area: function(value){
      let aux = this.areas.filter(area => area.id == value);
      this.areasSelected.push({
        area_id: aux[0].id,
        area_name: aux[0].name,
        status: aux[0].status
      })
      this.areas = this.areas.filter(area => area.id != value)
    }
  },
  async mounted() {
    await this.getAreas();
    this.valueData();
    this.toggleModal("modal-settings-entity-group");
  },
  methods: {
    async save(){
      let areasSelected = this.areasSelected.filter(area => area.status != 'saved');
      const form = {
        module_id: this.modalData.module_id,
        areas: areasSelected,
        user_id: this.currentUser.id
      };
      await AreasModuleService.saveData(form);
      this.getAreas();
      this.$emit("refreshTable")
      this.$emit("hideModal");
    },
    async getAreas(){
      const { data } = await AreasModuleService.getAreas();
      data.filter(area => this.initialAreaIds.includes(area.id));
      this.areas = data.map(area => {
        return {
          ...area,
          show: true
        }
      });
    },
    valueData(){
      let areas = JSON.parse(this.modalData.areas)
      this.areasSelected = areas ?? [];
      if(this.areasSelected.length > 0){
        this.initialAreaIds = this.areasSelected.map(area => area.area_id);
        this.areasSelected = this.areasSelected.map(area => {
          return {
            ...area,
            status: "saved"
          }
        });
      }
      
    },
    variantBadge(item){
      const variant = {
        "saved": "light-success",
        "selected": "light-primary",
        "deleted": "light-danger",
        "reasigned": "light-warning"
      }
      return variant[item.status];
    },
    deleteItem(item){
      if(item.status == "saved"){
        this.areasSelected.forEach(area => {
          if(area.area_id == item.area_id){
            area.status = 'deleted'
          }
        })       
      }else{
        this.areasSelected = this.areasSelected.filter(area => area.area_id != item.area_id);
      }
      console.log(item)
    },
    itemsFiltered(){
      return this.areasSelected.filter(item => item.status != 'deleted');
    },
    areasOptions(){
      return this.areas.filter(area => area.show);
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
</style>